import ComboVehiclePubInfoDetailModal from './combo-vehicle-pub-info-detail-modal.vue'
export default ComboVehiclePubInfoDetailModal
